import React from 'react';
import { Typography } from '@americanexpress/aqx-components';
import styles from './__styles__/index.scss?modules';

export const ContentPanel = ({ title, header }) => {
  return (
    <div className={styles.contentPanel}>
      <Typography className={styles.heroTitle} Component="div">
        {title}
      </Typography>
      <Typography className={styles.heroHeader} Component="h2">
        {header}
      </Typography>
    </div>
  );
};

const Desktop = ({ backImgUrl, title, header }) => {
  return (
    <div className={styles.desktopOuter}>
      <img src={backImgUrl} className={styles.desktopImg} alt="" />
      <ContentPanel title={title} header={header} />
    </div>
  );
};

export default React.memo(Desktop);
